import { allTasks } from "nanostores";

//#region src/util/ssr.ts
let stores = [];
const SSR_ENABLED = false;
function getStores() {
	return stores;
}
function addStore(store) {
	stores.push(store);
}
function cleanStores() {
	stores = [];
}
let clientInitialData;
function hydrateFromWindow() {
	if (typeof window !== "undefined" && window.__FRAGNO_INITIAL_DATA__) {
		clientInitialData = new Map(window.__FRAGNO_INITIAL_DATA__);
		delete window.__FRAGNO_INITIAL_DATA__;
		console.warn("hydrateFromWindow", { clientInitialData: Array.from(clientInitialData.entries()) });
	}
}
function getInitialData(key) {
	if (clientInitialData?.has(key)) {
		const data = clientInitialData.get(key);
		clientInitialData.delete(key);
		return data;
	}
}
function listenToStores() {
	for (const store of getStores()) store.listen(() => {});
}
async function getFinalStoreValues() {
	listenToStores();
	await allTasks();
	const stores$1 = getStores();
	const storesInitialValue = /* @__PURE__ */ new Map();
	for (const store of stores$1) {
		const value = store.get();
		if (!value || !store.key || value.loading) continue;
		storesInitialValue.set(store.key, value.data);
	}
	return storesInitialValue;
}

//#endregion
export { SSR_ENABLED, addStore, cleanStores, getFinalStoreValues, getInitialData, hydrateFromWindow };
//# sourceMappingURL=ssr.js.map